import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const SearchTag = ({ item, content, deleteFunction }) => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "#f3e5f5",
        color: "#7b1fa2",
        border: "1px solid #e1bee7",
        borderRadius: "20px",
        padding: "4px 12px",
        fontSize: "0.82rem",
        fontWeight: 500,
        marginRight: "6px",
        marginBottom: "6px",
      }}
    >
      <span style={{ cursor: "pointer" }}>{content}</span>
      <button
        onClick={() => deleteFunction(item)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#c62828",
          padding: 0,
          display: "flex",
          alignItems: "center",
          fontSize: "0.72rem",
          lineHeight: 1,
        }}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </div>
  );
};

export default SearchTag;
